import { BaseContainerModel } from '../../base-container.model';
import { bl_cms_app_version_hdr_RowClass } from '../../../dbschema';

export class CmsAppVersionHdrContainerModel extends BaseContainerModel {
    bl_cms_app_version_hdr: bl_cms_app_version_hdr_RowClass = new bl_cms_app_version_hdr_RowClass();
}
